import type { LogWithRelations } from '@owl/shared';

export type AlertSsePayload = {
  id: string;
  ruleId: string;
  applicationId: string;
  triggeredAt: string;
  triggeringLogId: string | null;
  channelsResult: Array<{
    channel: 'email' | 'webhook' | 'slack' | 'discord' | 'push';
    status: 'sent' | 'failed' | 'silenced';
    error?: string;
  }>;
};

export type SseFilter = { applicationId?: string; messageTypeIds?: string[] };

export type SseHandlers = {
  onLog?: (log: LogWithRelations) => void;
  onAlert?: (event: AlertSsePayload) => void;
  onError?: (err: Event) => void;
};

export function connectLogStream(filter: SseFilter, handlers: SseHandlers): () => void {
  const qs = new URLSearchParams();
  if (filter.applicationId) qs.set('application_id', filter.applicationId);
  if (filter.messageTypeIds?.length) qs.set('message_type_ids', filter.messageTypeIds.join(','));
  const url = `/admin/logs/stream${qs.toString() ? `?${qs}` : ''}`;
  const es = new EventSource(url, { withCredentials: true });

  es.addEventListener('log', (ev: MessageEvent<string>) => {
    try {
      const data = JSON.parse(ev.data) as LogWithRelations;
      handlers.onLog?.(data);
    } catch {
      // ignore malformed payloads
    }
  });

  es.addEventListener('alert', (ev: MessageEvent<string>) => {
    try {
      const data = JSON.parse(ev.data) as AlertSsePayload;
      handlers.onAlert?.(data);
    } catch {
      // ignore
    }
  });

  es.onerror = (ev) => handlers.onError?.(ev);

  return () => es.close();
}
